<template>
  <section class="section mobile_div section_bg container-fluid   first_page"     >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
<!--  <div class="section_header" v-if="is_load==true">-->
<!--    <nav aria-label="breadcrumb"  v-if="is_load==true" >-->
<!--      <ol class="breadcrumb">-->
<!--        <li class="breadcrumb-item"><router-link tag="a" to="/" >Главная</router-link></li>-->


<!--        <li class="breadcrumb-item active" aria-current="page" v-html="category.full_title"> </li>-->
<!--      </ol>-->
<!--    </nav>-->
<!--  </div>-->
    <div class="row " v-if="is_load==true && category.list_style=='default'">
      <div class="col-12 d-flex container justify-content-center">
        <ul class="second_section text-center nav mt-4 nav-tabs flex-column styled_ul">
          <li class="nav-item" v-for="page in pages" :key="page.id">
          <router-link class="nav-link"

              :to="{name: 'pages_page',params:{alias:category.alias,page_alias:page.alias}}">{{ page.title}}</router-link>
          </li>


        </ul>
      </div>

    </div>
    <div class="row" v-if="is_load==true && category.list_style=='3_in_1'">

        <div class="col-12 col-lg-4 col-md-4 mb-5 mb-lg-0 mt-2 mb-2 " v-for="page in pages" :key="page.id">
          <div class="p-3 block_row second_section">
            <h2 class="text-center">{{ page.title }}</h2>
            <editorjsrender  :blocks_json="page.content.blocks" :isshort="true"></editorjsrender>

            <div class="col-12 pt-3 d-flex justify-content-center">
              <router-link class="btn " :to="{name: 'pages_page',params:{alias:category.alias,page_alias:page.alias}}"
              >
                Читать далее
              </router-link>
            </div>
          </div>

        </div>



    </div>
    <div class="row" v-if="is_load==true && category.list_style=='2_in_1'">

      <div class="col-12 col-lg-6 col-md-6 mb-5 mb-lg-0 mt-2 mb-2 " v-for="page in pages" :key="page.id">
        <div class="p-3 block_row second_section">
          <h2 class="text-center">{{ page.title }}</h2>
          <editorjsrender  :blocks_json="page.content.blocks" :isshort="true"></editorjsrender>

          <div class="col-12 pt-3 d-flex justify-content-center">
            <router-link class="btn " :to="{name: 'pages_page',params:{alias:category.alias,page_alias:page.alias}}"
            >
              Читать далее
            </router-link>
          </div>
        </div>

      </div>



    </div>
  </section>


</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: "PagesCategory",
  data: function () {
    return {
      pages:[],
      category:[],
      is_load:false,

    }
  },
  mounted() {
    var app=this;
    let alias = app.$route.params.alias;
    Api.Pages_GetCategory(alias,function(data){


      app.pages=data.pages;
      app.category=data.category;
      app.is_load=true;
    },function(data){
      app.$router.push({name:'404'});
    })
  },
  components: {
    'editorjsrender': Editorjsrender,
    LoadingBlock
  }
}
</script>

<style scoped>

</style>